import {Component, computed, input, signal, ChangeDetectionStrategy} from "@angular/core";
import {LorenAsset} from "../loren-assets/interfaces/loren-asset.interface";
import {AssetMap, MapOptions} from "./asset-map";
import {
    LorenMapDetailsPopupComponent
} from "../loren-map/components/loren-map-details-popup/loren-map-details-popup.component";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {TranslocoPipe} from "@jsverse/transloco";


@Component({
    selector: "home-asset-map",
    templateUrl: "./home-asset-map.html",
    styleUrl: "./home-asset-map.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        AssetMap,
        LorenMapDetailsPopupComponent,
        MatButton,
        MatIcon,
        TranslocoPipe,
    ]
})
export class HomeAssetMap {
    assets = input.required<LorenAsset[]>();
    minimised = signal(false);
    selectedID = signal<number | null>(null);
    selected = computed<LorenAsset | null>(() => {
        if(this.selectedID() === null || this.minimised()) {
            return null;
        }

        return this.assets().find(x => x.id === this.selectedID()) ?? null;
    });
    visibleAssets = computed(() => this.minimised() ? [] : this.assets());
    mode = signal<MapOptions>({type: 'OVERVIEW'})

    toggleMinimised() {
        this.minimised.update(v => !v);
        if (this.minimised()) {
            this.selectedID.set(null);
        }
    }

    overview() {
        this.selectedID.set(null);
        this.mode.set({type: 'OVERVIEW'});
    }

    stopFollowing() {
        this.selectedID.set(null);
        this.mode.set({type: 'FREE'});
    }

    followAsset(asset: LorenAsset) {
        this.mode.set({type: 'FOLLOW', context: {assetID: asset.id}})
        this.selectedID.set(asset.id);
    }
}